export const CUSTOMER_FEEDBACK = 'waitrose/cms-page/customer-feedback';
